import { render } from "./InfoAboutAlarm.vue?vue&type=template&id=de66ff48&scoped=true&ts=true"
import script from "./InfoAboutAlarm.vue?vue&type=script&lang=ts"
export * from "./InfoAboutAlarm.vue?vue&type=script&lang=ts"

import "./InfoAboutAlarm.vue?vue&type=style&index=0&id=de66ff48&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de66ff48"]])

export default __exports__